// extracted by mini-css-extract-plugin
module.exports = {"goback":"Details_goback__2NOxR","card":"Details_card__7af2v","img":"Details_img__TyNFR"};